module.exports = __webpack_public_path__ + "media/images/sp/lp/bg-ribbon-right-cbf1f458e04d8d799de4f73d816c8c72.svg";